import { FaberApi } from 'api'

class AuditApi {
  static getUploadPaidPurchaseAuditLog(
    faberToken: string,
    page: number,
    limit: number
  ) {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    })

    return FaberApi.httpGet(
      `/audit/purchase/upload?${queryParams.toString()}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      false
    ).then((res) => res.data)
  }
}

export default AuditApi
